import classes from './BackDrop.module.css';

const BackDrop = (props) => {
    if (!props.showBackDrop) {
        return null;
    }
    return (
        <div className={classes.BackDrop} onClick={props.closeDrawer}></div>
    );
}

export default BackDrop;